import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { GroupedBracketedDiv } from "../Logic/AndGroupEditor";
import { ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringNotContainsExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringNotContainsExpression";

export class StringNotContainsExpressionEditor extends ExpressionRuleEditor<StringNotContainsExpression> {
    render() {
        return (
            <GroupedBracketedDiv issue={this.ruleData!.getValidationIssues()[0]}>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value1!} />
                </ExpressionPiece>
                <ExpressionPiece> not contains </ExpressionPiece>
                <ExpressionPiece>
                    <ExpressionValueRenderer el={this.ruleData!.value2!} />
                </ExpressionPiece>
            </GroupedBracketedDiv>
        );
    }
}
